function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import { PageBaseComponent } from "../../library/cms/page-components";
import { TinyEditable } from "../../library/cms/editor";
import { H3Title } from "../../library/cms/content-components";
import { MultiSlideCarouselComponent } from "../../library/cms/content-components";

class AwardItem extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "press-award-item"
    }, /*#__PURE__*/React.createElement(TinyEditable, {
      onChange: this.props.onText1Change,
      content: this.props.text1,
      active: this.props.active,
      cls: "top-text"
    }), /*#__PURE__*/React.createElement(H3Title, {
      active: this.props.active,
      title: this.props.title,
      onChange: this.props.onTitleChange,
      cls: "italic"
    }), /*#__PURE__*/React.createElement(TinyEditable, {
      onChange: this.props.onText2Change,
      content: this.props.text2,
      active: this.props.active,
      cls: "bottom-text"
    }));
  }

}

class ReviewItem extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(H3Title, {
      active: this.props.active,
      title: this.props.title,
      onChange: this.props.onTitleChange,
      cls: "italic"
    }), /*#__PURE__*/React.createElement(TinyEditable, {
      onChange: this.props.onTextChange,
      content: this.props.text,
      active: this.props.active,
      cls: "byline"
    }));
  }

}

export class AwardsComponent extends PageBaseComponent {
  constructor(props) {
    super(props);

    _defineProperty(this, "onTitle1Change", title => {
      this.state.component.content.title1 = title;
      this.setState(this.state.component);
    });

    _defineProperty(this, "onTitle2Change", title => {
      this.state.component.content.title2 = title;
      this.setState(this.state.component);
    });

    _defineProperty(this, "onTitle3Change", title => {
      this.state.component.content.title3 = title;
      this.setState(this.state.component);
    });

    _defineProperty(this, "onTitle4Change", title => {
      this.state.component.content.title4 = title;
      this.setState(this.state.component);
    });

    _defineProperty(this, "onText11Change", text => {
      this.state.component.content.text11 = text;
      this.setState(this.state.component);
    });

    _defineProperty(this, "onText12Change", text => {
      this.state.component.content.text12 = text;
      this.setState(this.state.component);
    });

    _defineProperty(this, "onText21Change", text => {
      this.state.component.content.text21 = text;
      this.setState(this.state.component);
    });

    _defineProperty(this, "onText22Change", text => {
      this.state.component.content.text22 = text;
      this.setState(this.state.component);
    });

    _defineProperty(this, "onText31Change", text => {
      this.state.component.content.text31 = text;
      this.setState(this.state.component);
    });

    _defineProperty(this, "onText32Change", text => {
      this.state.component.content.text32 = text;
      this.setState(this.state.component);
    });

    _defineProperty(this, "onText41Change", text => {
      this.state.component.content.text41 = text;
      this.setState(this.state.component);
    });

    _defineProperty(this, "onText42Change", text => {
      this.state.component.content.text42 = text;
      this.setState(this.state.component);
    });
  }

  componentDidMount() {
    super.componentDidMount();
  }

  onGetContent(d) {
    var content = {
      title1: this.state.component.content.title1,
      title2: this.state.component.content.title2,
      title3: this.state.component.content.title3,
      title4: this.state.component.content.title4,
      text11: this.state.component.content.text11,
      text11: this.state.component.content.text11,
      text11: this.state.component.content.text11,
      text12: this.state.component.content.text12,
      text21: this.state.component.content.text21,
      text22: this.state.component.content.text22,
      text31: this.state.component.content.text31,
      text32: this.state.component.content.text32,
      text41: this.state.component.content.text41,
      text42: this.state.component.content.text42
    };
    var data = {
      key: this.props.contentKey,
      content: content
    };
    return data;
  }

  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "press-awards"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row-1"
    }, /*#__PURE__*/React.createElement(AwardItem, {
      text1: this.state.component.content.text11,
      title: this.state.component.content.title1,
      text2: this.state.component.content.text12,
      onText1Change: this.onText11Change,
      onText2Change: this.onText12Change,
      onTitleChange: this.onTitle1Change,
      active: this.state.component.active
    })), /*#__PURE__*/React.createElement("div", {
      className: "row-2"
    }, /*#__PURE__*/React.createElement(AwardItem, {
      text1: this.state.component.content.text21,
      title: this.state.component.content.title2,
      text2: this.state.component.content.text22,
      onText1Change: this.onText21Change,
      onText2Change: this.onText22Change,
      onTitleChange: this.onTitle2Change,
      active: this.state.component.active
    }), /*#__PURE__*/React.createElement(AwardItem, {
      text1: this.state.component.content.text31,
      title: this.state.component.content.title3,
      text2: this.state.component.content.text32,
      onText1Change: this.onText31Change,
      onText2Change: this.onText32Change,
      onTitleChange: this.onTitle3Change,
      active: this.state.component.active
    }), /*#__PURE__*/React.createElement(AwardItem, {
      text1: this.state.component.content.text41,
      title: this.state.component.content.title4,
      text2: this.state.component.content.text42,
      onText1Change: this.onText41Change,
      onText2Change: this.onText42Change,
      onTitleChange: this.onTitle4Change,
      active: this.state.component.active
    })));
  }

}
export class ReviewsComponent extends PageBaseComponent {
  constructor(props) {
    super(props);

    _defineProperty(this, "onTitle1Change", title => {
      this.state.component.content.title1 = title;
      this.setState(this.state.component);
    });

    _defineProperty(this, "onTitle2Change", title => {
      this.state.component.content.title2 = title;
      this.setState(this.state.component);
    });

    _defineProperty(this, "onTitle3Change", title => {
      this.state.component.content.title3 = title;
      this.setState(this.state.component);
    });

    _defineProperty(this, "onText1Change", text => {
      this.state.component.content.text1 = text;
      this.setState(this.state.component);
    });

    _defineProperty(this, "onText2Change", text => {
      this.state.component.content.text2 = text;
      this.setState(this.state.component);
    });

    _defineProperty(this, "onText3Change", text => {
      this.state.component.content.text3 = text;
      this.setState(this.state.component);
    });
  }

  componentDidMount() {
    super.componentDidMount();
  }

  onGetContent(d) {
    var content = {
      title1: this.state.component.content.title1,
      title2: this.state.component.content.title2,
      title3: this.state.component.content.title3,
      text1: this.state.component.content.text1,
      text2: this.state.component.content.text2,
      text3: this.state.component.content.text3
    };
    var data = {
      key: this.props.contentKey,
      content: content
    };
    return data;
  }

  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "reviews"
    }, /*#__PURE__*/React.createElement(ReviewItem, {
      text: this.state.component.content.text1,
      title: this.state.component.content.title1,
      onTextChange: this.onText1Change,
      onTitleChange: this.onTitle1Change,
      active: this.state.component.active
    }), /*#__PURE__*/React.createElement(ReviewItem, {
      text: this.state.component.content.text2,
      title: this.state.component.content.title2,
      onTextChange: this.onText2Change,
      onTitleChange: this.onTitle2Change,
      active: this.state.component.active
    }), /*#__PURE__*/React.createElement(ReviewItem, {
      text: this.state.component.content.text3,
      title: this.state.component.content.title3,
      onTextChange: this.onText3Change,
      onTitleChange: this.onTitle3Change,
      active: this.state.component.active
    }));
  }

}
export class CatalogCarouselComponent extends MultiSlideCarouselComponent {
  constructor(props) {
    super(props);
    this.cls = 'default-carousel catalogs';
  }

  getNodes() {
    super.getNodes();
    var index = 0;
    var nodes = this.state.component.content.media.map(file => {
      var href = file.link;
      index += 1;
      var blank = '_blank';
      var title = file.title;
      if (!title) title = 'content image';
      return /*#__PURE__*/React.createElement("carousel-item", {
        key: index
      }, /*#__PURE__*/React.createElement("a", {
        href: href,
        target: blank
      }, /*#__PURE__*/React.createElement("img", {
        src: file.url,
        alt: title,
        title: title
      }), /*#__PURE__*/React.createElement("h4", {
        className: "italic"
      }, file.title), /*#__PURE__*/React.createElement("span", {
        className: "date-byline"
      }, file.meta)));
    });
    return nodes;
  }

}
export class AwardsCarouselComponent extends MultiSlideCarouselComponent {
  constructor(props) {
    super(props);
    this.cls = 'default-carousel catalogs';
  }

  getNodes() {
    super.getNodes();
    var index = 0;
    var nodes = this.state.component.content.media.map(file => {
      var href = file.link;
      index += 1;
      var blank = '_blank';
      var title = file.title;
      if (!title) title = 'content image';
      return /*#__PURE__*/React.createElement("carousel-item", {
        key: index
      }, /*#__PURE__*/React.createElement("a", {
        href: href,
        target: blank
      }, /*#__PURE__*/React.createElement("img", {
        src: file.url,
        alt: title,
        title: title
      }), /*#__PURE__*/React.createElement("h3", {
        className: "italic awards-title-text"
      }, file.title), /*#__PURE__*/React.createElement("div", {
        className: "awards-bottom-text"
      }, file.meta)));
    });
    return nodes;
  }

}
export default {
  AwardsComponent,
  AwardsCarouselComponent,
  CatalogCarouselComponent,
  ReviewsComponent
};